import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NgSelectizeModule} from 'ng-selectize';
import {SharedModule} from '../shared/shared.module';

import {AccountForgotPageComponent} from './account-forgot-page/account-forgot-page.component';
import {AccountResetPageComponent} from './account-reset-page/account-reset-page.component';
import {AppFooterComponent} from './app-footer/app-footer.component';
import {AppHeaderComponent} from './app-header/app-header.component';
import {CredentialsFormComponent} from './credentials-form/credentials-form.component';
import {DisplayFormComponent} from './display-form/display-form.component';
import {ErrorPageComponent} from './error-page/error-page.component';
import {InvoiceSettingsFormComponent} from './invoice-settings-form/invoice-settings-form.component';
import {LoginAsPageComponent} from './login-as-page/login-as-page.component';
import {LoginPageComponent} from './login-page/login-page.component';
import {LogoutPageComponent} from './logout-page/logout-page.component';
import {MasqueradeBannerComponent} from './masquerade-banner/masquerade-banner.component';
import {NotFoundPageComponent} from './not-found-page/not-found-page.component';
import {ProfileAvatarImageComponent} from './profile-avatar-image/profile-avatar-image.component';
import {ProfileFormComponent} from './profile-form/profile-form.component';
import {RegisterCompleteComponent} from './register-complete/register-complete.component';
import {RegisterConfirmComponent} from './register-confirm/register-confirm.component';
import {RegisterExpiredComponent} from './register-expired/register-expired.component';
import {TermsPageComponent} from './terms-page/terms-page.component';
import {TimecardSettingsFormComponent} from './timecard-setting-form/timecard-settings-form.component';
import {UserAccountInformationComponent} from './user-account-information/user-account-information.component';
import {UserAccountSettingsComponent} from './user-account-settings/user-account-settings.component';
import {UserControlNavComponent} from './user-control-nav/user-control-nav.component';
import {DiversityInsightComponent} from '../client/diversity-insight/diversity-insight.component';
import {DiversityDetailViewComponent} from '../client/diversity-insight/diversity-detail-view/diversity-detail-view.component';
import {DoughnutChartComponent} from '../client/diversity-insight/doughnut-chart/doughnut-chart.component';
import {ChartsModule} from 'ng2-charts';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {HorizontalDiversityBarChartComponent} from '../client/diversity-insight/horizontal-diversity-bar-chart/horizontal-diversity-bar-chart.component';
import {DiversityInsightLegendComponent} from '../client/diversity-insight/diversity-insight-legend/diversity-insight-legend.component';
import {DiversityInsightLegendItemComponent} from '../client/diversity-insight/diversity-insight-legend/diversity-insight-legend-item/diversity-insight-legend-item.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HorizontalDiversityDetailViewComponent} from '../client/diversity-insight/horizontal-diversity-detail-view/horizontal-diversity-detail-view.component';
import {DiversityInsightService} from '../client/diversity-insight/service/diversity-insight.service';

/**
 * Provides core application endpoints.
 */
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NgSelectizeModule,
    ChartsModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    NgxDaterangepickerMd.forRoot()
  ],
  declarations: [
    AccountForgotPageComponent,
    AccountResetPageComponent,
    AppFooterComponent,
    AppHeaderComponent,
    ErrorPageComponent,
    LoginPageComponent,
    LoginAsPageComponent,
    LogoutPageComponent,
    NotFoundPageComponent,
    TermsPageComponent,
    UserAccountSettingsComponent,
    UserAccountInformationComponent,
    ProfileFormComponent,
    CredentialsFormComponent,
    UserControlNavComponent,
    DisplayFormComponent,
    InvoiceSettingsFormComponent,
    TimecardSettingsFormComponent,
    RegisterCompleteComponent,
    RegisterConfirmComponent,
    RegisterExpiredComponent,
    ProfileAvatarImageComponent,
    MasqueradeBannerComponent,
    DiversityInsightComponent,
    DiversityDetailViewComponent,
    DoughnutChartComponent,
    HorizontalDiversityBarChartComponent,
    DiversityInsightLegendComponent,
    DiversityInsightLegendItemComponent,
    HorizontalDiversityDetailViewComponent
  ],
  providers: [
    DiversityInsightService
  ],
  entryComponents: [
    AccountForgotPageComponent,
    AccountResetPageComponent,
    AppFooterComponent,
    AppHeaderComponent,
    ErrorPageComponent,
    LoginPageComponent,
    LoginAsPageComponent,
    LogoutPageComponent,
    NotFoundPageComponent,
    TermsPageComponent,
    UserAccountSettingsComponent,
    UserAccountInformationComponent,
    RegisterCompleteComponent,
    RegisterConfirmComponent,
  ],
  exports: [
    AppHeaderComponent,
    AppFooterComponent
  ]
})
export class CoreModule {
}
